import { Dropdown } from "@nova/component-dropdown"
import * as Icons from "@nova/component-icons"
import { InputOutlined } from "@nova/ds-component-input"
import { DateRangeValue, datePresetLabel, datePresets, toISODate } from "./dateRange"

export const DateRangePicker = ({
    value,
    onChange,
    applyOnPresetClick,
}: {
    value: DateRangeValue
    onChange: (value: DateRangeValue) => void
    applyOnPresetClick?: boolean
}) => {
    const from = "from" in value ? value.from : ""
    const to = "from" in value ? value.to : toISODate(new Date())

    return (
        <>
            <div className="flex flex-col gap-px">
                {datePresets.map((preset) => (
                    <Dropdown.ButtonItem
                        key={preset}
                        clickBehaviour={applyOnPresetClick ? "close" : "keep-open"}
                        onClick={() => onChange({ preset })}
                    >
                        <span className="flex-1 truncate">{datePresetLabel(preset)}</span>
                        <span className="w-5 h-5 shrink-0 flex items-center justify-center">
                            {"preset" in value && value.preset === preset && (
                                <Icons.SmallIcon Icon={Icons.Checkmark} className="text-blue-500" />
                            )}
                        </span>
                    </Dropdown.ButtonItem>
                ))}
            </div>

            <div className="flex items-center gap-2 px-4 py-3 text-gray-100 border-t border-white-200">
                <span className="text-sm">Period</span>
                <InputOutlined
                    type="date"
                    value={from}
                    onChange={(e) => {
                        const next = e.currentTarget.value
                        if (next && to) onChange({ from: next, to })
                    }}
                    className="flex-1"
                />
                <small>to</small>
                <InputOutlined
                    type="date"
                    value={to}
                    onChange={(e) => {
                        const next = e.currentTarget.value
                        if (from && next) onChange({ from, to: next })
                    }}
                    className="flex-1"
                />
            </div>
        </>
    )
}
